import React from 'react';
import { Button } from '@/components/ui/button';
import { ArrowLeft } from 'lucide-react';

interface PlayerProgramHeaderProps {
  onBack: () => void;
}

export const PlayerProgramHeader: React.FC<PlayerProgramHeaderProps> = ({
  onBack,
}) => {
  return (
    <div className="flex items-center gap-4 mb-6">
      <Button 
        onClick={onBack}
        variant="ghost" 
        size="sm"
        className="hover:bg-white/50"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Player
      </Button>
    </div>
  );
};